import "ekko-lightbox/dist/ekko-lightbox.css"
require("ekko-lightbox")

$(document).on("click", '[data-toggle="lightbox"]', function (event) {
  event.preventDefault()
  $(this).ekkoLightbox({
    alwaysShowClose: false,
  })
})
